import Braserrie21 from '../Ruko/Braseif  2.webp'
import Braserrie22 from '../Ruko/Braseif  2.webp'


const Braserrie2images =[
Braserrie21,Braserrie22
]

export default Braserrie2images;